module.exports = __webpack_public_path__ + "static/img/Bachelor_010529.27864b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010529.jpg
// module id = 181
// module chunks = 0